import type { ReactNode } from 'react'
import { ApiError } from '../../api/client'
import { QueryState } from '../focus/shared'
export const hasStatus = (error: unknown, status: number) => error instanceof ApiError && error.status === status
export const unavailable = (error: unknown) => hasStatus(error, 404) || hasStatus(error, 503)
export function BrainQuery({ query, children }: { query: { isPending: boolean; isError: boolean; error: unknown; refetch: () => unknown }; children: ReactNode }) {
  if (query.isError && unavailable(query.error)) return <p role="status" className="lc-empty">中枢还没开</p>
  return <QueryState query={query}>{children}</QueryState>
}
export const stamp = (at: string | number) => new Date(at).toLocaleString('zh-CN', { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' })
export const brainKey = ['hub', 'brain'] as const
